import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const LOCAL_STORAGE_KEY = 'collect-info-modal';

export interface CollectInfoModalState {
  modalShown: boolean;
  setModalShown: (value: boolean) => void;
}

export const useCollectInfoModalStore = create<CollectInfoModalState>()(
  persist(
    set => ({
      modalShown: false,
      setModalShown: (value: boolean) => set({ modalShown: value }),
    }),
    { name: LOCAL_STORAGE_KEY, storage: createJSONStorage(() => window.localStorage) },
  ),
);
